import { render } from "./EditSet.vue?vue&type=template&id=fd6e962c"
import script from "./EditSet.vue?vue&type=script&lang=js"
export * from "./EditSet.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__